import plainWhiteShirt from "../assets/cloths/plainShirt.png";
import denimJacket from "../assets/cloths/denimJacket.png";
import blackPoloShirt from "../assets/cloths/blackPoloShirt.png";
import blueSweatShirt from "../assets/cloths/blueSweatShirt.png";
import bluePlainShirt from "../assets/cloths/bluePlainShirt.png";
import darkBlueShirt from "../assets/cloths/darkBlueShirt.png";
import outcastTShirt from "../assets/cloths/outcastTShirt.png";
import poloPlainShirt from "../assets/cloths/poloPlainShirt.png";
import grayPoloShirt from "../assets/cloths/grayPoloShirt.png";
import redShirt from "../assets/cloths/redShirt.png";
import poloWhiteShirt from "../assets/cloths/poloWhiteShirt.png";
import pinkCasualShirt from "../assets/cloths/pinkCasualShirt.png";

const clothesData = [
  {
    id: "1",
    name: "Plain White Shirt",
    price: "29.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: plainWhiteShirt,
    category: "Female",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "newArrival",
  },
  {
    id: "2",
    name: "Denim Jacket",
    price: "69.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: denimJacket,
    category: "Female",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "newArrival",
  },
  {
    id: "3",
    name: "Black Polo Shirt",
    price: "49.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: blackPoloShirt,
    category: "Female",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "newArrival",
  },
  {
    id: "4",
    name: "Blue Sweatshirt",
    price: "49.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: blueSweatShirt,
    category: "Female",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "newArrival",
  },
  {
    id: "5",
    name: "Blue Plain Shirt",
    price: "29.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: bluePlainShirt,
    category: "Male",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "newArrival",
  },
  {
    id: "6",
    name: "Dark Blue Shirt",
    price: "89.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: darkBlueShirt,
    category: "Male",
    tags: "newArrival",
  },
  {
    id: "7",
    name: "Outcast T Shirt",
    price: "19.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: outcastTShirt,
    category: "Male",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "newArrival",
  },
  {
    id: "8",
    name: "Polo Plain Shirt",
    price: "29.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: poloPlainShirt,
    category: "Male",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "newArrival",
  },
  {
    id: "9",
    name: "Gray Polo Shirt",
    price: "49.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: grayPoloShirt,
    category: "",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "topSeller",
  },
  {
    id: "10",
    name: "Red Shirt",
    price: "69.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: redShirt,
    category: "Female",
    tags: "topSeller",
  },
  {
    id: "11",
    name: "Polo White Shirt",
    price: "29.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: poloWhiteShirt,
    category: "Female",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "topSeller",
  },
  {
    id: "12",
    name: "Pink Casual Shirt",
    price: "39.00",
    offerPrice: "69.00",
    description:
      "A classic t-shirt never goes out of style. This is our most premium collection of shirt. This plain white shirt is made up of pure cotton and has a premium finish.",
    image: pinkCasualShirt,
    category: "Female",
    size: ["Small", "Medim", "Large", "Extra Large"],
    tags: "topSeller",
  },
];

export default clothesData;
